import React from 'react';
import MViewItemCopyFormList from './MViewItemCopyFormList';

function MViewItemCopyForm(props) {
  const {
    auth,
    scope,
    loading,
    initialValues,
  } = props;

  let questions = initialValues?.questions && JSON.parse(initialValues.questions);
  let answers = initialValues?.answers && JSON.parse(initialValues.answers);

  return (
    <div className='content mx-3 overflow-auto'>
      <div className='c-table'>
        <table className='table is-fullwidth is-bordered is-hoverable is-narrow'>
          <thead>
            <tr>
              <th className='has-text-centered' style={{ width: 30 }}>
                No
              </th>
              <th className='has-text-centered' style={{ width: 200 }}>
                Pertanyaan
              </th>
              <th className='has-text-centered' style={{ width: 150 }}>
                Jawaban
              </th>
            </tr>
          </thead>
          <tbody>
            <MViewItemCopyFormList
              auth={auth}
              scope={scope}
              loading={loading}
              questions={questions}
              answers={answers}
            />
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default MViewItemCopyForm;
